SP.lang.Class.define("SP.sitekit.form.field.Select", {
	extend: "SP.sitekit.form.field.Field",

	init: function (el, options) {
		this._super.apply(this, arguments);
	},

	isEmpty: function () {
		var el = null;
		if (this._control.value === "") {
			el = this._control.querySelector(":not([value]), [value=\"\"]");
		} else {
			el = this._control.querySelector("[value=\"" + this._control.value + "\"]");
		}
		return el && el.innerHTML === "";
	},

	getValue: function () {
		return this._control[this._control.selectedIndex].value;
	}

});
